import React, { Component } from 'react';
import '../../inc/genstyle.css';
import '../iinc/iStyle.css';
import { FormErrors } from '../../inc/error-form';
import '../iinc/iGlobal';
import parse from 'html-react-parser';

const authKey = global.config.authBearerKey+"##"+global.config.kindcode[4];

class ISendNotifDetail extends Component {
  constructor (props) {
    super(props);
    this.state = {
        stPopTitle: '',
        client_name: '',
        to: '',
        to_pic: '',
        cc: '',
        subject: '',
        message: '',
        contentoth: '',
        type_dest_email: '',
        to_general: '',
        to_pic: '',
        cc_pic: '',
        formErrors: {type_dest_email: '', to: '', cc: '', subject: '', message: ''},
        typedestemailValid: false,
        toValid: false,
        subjectValid: false,
        messageValid: false,
        formValid: false,
    }
    this.handleSubmit = this.handleSubmit.bind(this);
   
  }
  
  setTypeDest(e) {
    var setStatez = {};
    var name = e.target.name;
    var value = e.target.value;
    
    if(value === "1") {
      setStatez.to = this.state.to_general;
      setStatez.cc = "";
    } else { 
      setStatez.to = this.state.to_pic;
      setStatez.cc = this.state.cc_pic;
     }
    setStatez[name] = value;

    this.setState(setStatez, () => {
      this.validateField(name, value)
  });
  }
  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let typedestemailValid = this.state.toValid;
    let toValid = this.state.toValid;
    // let ccValid = this.state.ccValid;
    let subjectValid = this.state.subjectValid;
    let messageValid = this.state.messageValid;

    switch(fieldName) {
        case 'type_dest_email': 
            typedestemailValid = value.trim().length > 0;
            fieldValidationErrors.to = typedestemailValid ? '' : '"destination" email need to be selected';
            break;
        case 'to': 
            toValid = value.trim().length > 0;
            fieldValidationErrors.to = toValid ? '' : '"to" email need to be filled';
            break;
        case 'subject': 
            subjectValid = value.trim().length > 0;
            fieldValidationErrors.subject = subjectValid ? '' : '"subject" email need to be filled';
            break;
        case 'message': 
            messageValid = value.trim().length > 0;
            fieldValidationErrors.message = messageValid ? '' : '"message" email need to be filled';
            break;
        default:
            break;
    }
    this.setState({formErrors: fieldValidationErrors,
                    typedestemailValid: typedestemailValid,
                    toValid: toValid,
                    subjectValid: subjectValid,
                    messageValid: messageValid,
                }, this.validateForm);
  }
  validateForm() {
    this.setState({formValid: this.state.typedestemailValid});
  }

  errorClass(error) {
    return(error.length === 0 ? '' : 'has-error');
  }

  urlsendMail(valContent) {
    document.getElementById('loading-area').style.display = 'block'; 
    fetch(global.config.urlLink+"/sendnotifmanual", {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }, body : valContent
    }).then(response => {
        if(response.status === 200) {
            return response.json()
        } else {
            console.log('Something happened wrong');
        }
    }).then(resJson => {
        document.getElementById('loading-area').style.display = 'none'; 
        document.getElementById('btSendmail').disabled = true;
        document.getElementById('btSendmail').style.background = "#999999";
    }).catch(err => {
        console.log(err);
    });
    
}
handleSubmit(e) {
    e.preventDefault();
    if(this.state.type_dest_email !== '' && this.state.to !== '' && this.state.subject !== '' && this.state.message !== '') {
        document.getElementById('loading-area').style.display = 'block'; 
        var to_mail = this.state.to;
        var cc_mail = this.state.cc;
        var subject_mail = this.state.subject;
        var message_mail = this.state.message;
        
        var resExtractContent = JSON.parse(this.state.contentoth);
        var resExtractSendContent = JSON.parse(resExtractContent.sendContent);
        var notifcodes_dt = new Date(resExtractContent.dateend_periode._seconds*1000);
        var notifcodes = notifcodes_dt.getFullYear()+("0"+(notifcodes_dt.getMonth()+1)).slice(-2)+"01"+resExtractSendContent.noticeCount;
        var contentSend = {
            "client_id": resExtractContent.client_id,
            "client_name": resExtractContent.client_name,
            "domain_name": resExtractContent.domain_name,
            "client_country": resExtractContent.client_country,
            "licence_id": resExtractContent.licence_id,
            "licence_type": resExtractContent.licence_type,
            "end_periode": resExtractContent.end_periode,
            "licence_seat": resExtractContent.licence_seat,
            "clientpic": resExtractContent.clientpic,
            "drivelic": resExtractContent.drivelic,
            "sendContent": resExtractContent.sendContent,
            "result": resExtractContent.result,
            "numSent": resExtractContent.numSent,
            "to_mail": to_mail,
            "cc_mail": cc_mail,
            "subject_mail": subject_mail,
            "message_mail": message_mail,
            "noticecount": resExtractSendContent.noticeCount,
            "dateend_periode": resExtractContent.dateend_periode,
            "noticecodes": notifcodes

        };
        this.urlsendMail(JSON.stringify(contentSend));
        
    } else {
        var arrfieldName = ['type_dest_email','to','subject','message'];
        var arrvalue = [this.state.type_dest_email,this.state.to,this.state.subject,this.state.message];
        for(var ck in arrfieldName) {
            this.validateField(arrfieldName[ck], arrvalue[ck]);
        }
    }
    
  }

  componentDidMount() {
      var othersContent = JSON.parse(document.getElementById("contentoth").innerText);
      var resSendContent = JSON.parse(othersContent.sendContent);
      this.setState({
          stPopTitle: '',
          client_name: othersContent.client_name,
          to: '',
          cc: '',
          subject: resSendContent.subject,
          message: resSendContent.message,
          contentoth: document.getElementById("contentoth").innerText,
          type_dest_email: '',
          to_general: "sgs-all@point-star.com",
          to_pic: resSendContent.to,
          cc_pic: resSendContent.cc,
      }); 
  }
  render() {
    return (
      <div className="main-container">
          <div className="mgT20">
            <div className="mgL20">
              <div className="st3Title">{this.state.client_name}</div>
            </div>
            <div className="mgT20 mgL20">
              {/* ---- */}
              <div  className="content-container card card-body">
              <form onSubmit={this.handleSubmit}>
                  <div className="flex-container mgT20">
                      <div className="align-items-start mgR20"><h6>Send notification email to : </h6></div>
                      <div className="divMiddle mgL20">
                        <div className="d-flex">
                            <input className="form-check-input" type="radio" 
                                    name="type_dest_email" id="type_dest_email1" 
                                    value="1" 
                                    onChange={(e) => this.setTypeDest(e)} 
                                    checked={this.state.type_dest_email === "1"}
                            />
                            <label className="form-check-label" htmlFor="type_dest_email1" style={{marginLeft:"5px"}}>
                            {this.state.to_general}
                            </label>
                        </div>
                        <div className="d-flex">
                            <input className="form-check-input" type="radio" 
                                    name="type_dest_email" id="type_dest_email2" 
                                    value="2" 
                                    onChange={(e) => this.setTypeDest(e)} 
                                    checked={this.state.type_dest_email === "2"}
                            />
                            <label className="form-check-label" htmlFor="type_dest_email2" style={{marginLeft:"5px"}}>
                            PIC Client
                            </label>
                        </div>
                      </div>
                  </div>
                  <div className="flex-container mgT20">
                      <div className="divMiddle"><h6>To :</h6></div>
                      <div className="divMiddle mgL20">
                          <h6>{this.state.to}</h6> 
                          { <FormErrors formErrors={this.state.formErrors.to}/>  }
                      </div>
                      
                  </div>
                  <div className="flex-container mgT20">
                      <div className="divMiddle"><h6>CC :</h6></div>
                      <div className="divMiddle mgL20">
                            <h6>{this.state.cc}</h6>
                            { <FormErrors formErrors={this.state.formErrors.cc}/>  }
                      </div>
                  </div>
                  <div className="mgT20">
                      <div className="divMiddle"><h6>Subject :</h6></div>
                      <div className="divMiddle">
                            <h6>{this.state.subject}</h6> 
                            { <FormErrors formErrors={this.state.formErrors.subject}/>  }
                      </div>
                  </div>
                  
                  <div className="mgT30">
                    <div><h6>Message :</h6></div>
                    <div>{parse(this.state.message)}</div> 
                    <div className="mgT05">
                    { <FormErrors formErrors={this.state.formErrors.message}/>  }
                    </div>
                  </div>
                  <div className="mgT50">
                    <button type="submit" id="btSendmail" className="w100p submitButton">Send Email</button>
                    <div className="mgT05">
                      <div style={{color:"#FC6060", fontSize: "9.5pt"}}>{this.state.formErrors.to}</div>
                      <div style={{color:"#FC6060", fontSize: "9.5pt"}}>{this.state.formErrors.cc}</div>
                      <div style={{color:"#FC6060", fontSize: "9.5pt"}}>{this.state.formErrors.subject}</div>
                      <div style={{color:"#FC6060", fontSize: "9.5pt"}}>{this.state.formErrors.message}</div>
                    </div>
                  </div>
              </form>
              </div>

              {/* ---- */}
              
            </div>
            
          </div>
          <div id="loading-area" className="divHide loading"></div> 
      </div>
    );
  }
}
 
export default ISendNotifDetail;